<template>
    <span v-if="meta" class="label" :class="meta.class" title="Signoff status">
        {{ meta.text }}
    </span>
</template>

<script>
/*
    Reusable coloured "Awaiting Signoff" badge.

    Mirrors partials/signoff-badge.blade.php for client-side reactive
    surfaces (Signoff page lists, quote-edit when status changes
    without a page reload, calendar tooltips). When the partial is
    fine, prefer it — fewer Vue mount points.

    Props
      status   : pending_sales | pending_won | pending_inspection
                 | auto_approved | null
*/
export default {
    props: {
        status: {
            type: String,
            default: null,
        },
    },
    computed: {
        meta() {
            const map = {
                pending_sales:      { class: 'label-warning', text: 'Awaiting Sales Signoff' },
                pending_won:        { class: 'label-info',    text: 'Awaiting Production Signoff' },
                pending_inspection: { class: 'label-primary', text: 'Awaiting Inspection' },
                auto_approved:      { class: 'label-default', text: 'Auto-approved' },
            };
            return this.status ? map[this.status] : null;
        },
    },
};
</script>
